import userApi from '@/api/login'

import { handleReslt } from '@/utils'

export default {
  namespaced: true,
  state: {
    loginStatus: false,
    userInfo: {}
  },
  mutations: {
    saveUserInfo (state, payload) {
      state.userInfo = payload
    }
  },
  actions: {
    // 登录
    loginAction (context, payload) {
      return userApi.hanldeLogin(payload).then(res => {
        context.commit('saveUserInfo', res.result)
        return handleReslt(res)
      })
    },
    // 安全退出
    logoutAction (context, payload) {
      return userApi.hanldeLoginOut(payload).then(res => {
        return handleReslt(res)
      })
    },
    // 登录后查菜单刷新
    async userReloadAction (context, payload) {
      return await userApi.userReloadHander(payload).then(async res => {
        await context.commit('saveUserInfo', res.result)
        return await handleReslt(res)
      })
    }
  },
  getters: {
    testGetterGetter (state) {
      return state.loginStatus
    }
  }
}
